var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  fill: "none",
  viewBox: "0 0 14 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#080808",
  d: "M6.631.927.25 11.979h12.762zm.002 9.879c-.564 0-.95-.402-.95-.953 0-.567.39-.958.948-.958.564 0 .941.391.948.958 0 .55-.374.953-.946.953m.724-2.56H5.994L5.772 4.4H7.58z"
})));
export default SvgExclamation;